import React from "react";

import LeafyFront from "./Leafy/leafy-front";
import LeafyBack from "./Leafy/leafy-back";
import DarkFront from "./Dark/dark-front";
import DarkBack from "./Dark/dark-back";
import FloralFront from "./Floral/floral-front";
import FloralBack from "./Floral/floral-back";

const TemplatePreview = ({ selection, data }) => {
  return (
    <div className="container-fluid template-preview">
      <div className="row">
        {selection === "leafy" && (
          <>
            <div className="col-custom-template px-3 mb-3 mb-md-0">
              <LeafyFront data={data} />
            </div>
            <div className="col-custom-template">
              <LeafyBack data={data} />
            </div>
          </>
        )}
        {selection === "dark" && (
          <>
            <div className="col-custom-template px-3 mb-3 mb-md-0">
              <DarkFront data={data} />
            </div>
            <div className="col-custom-template">
              <DarkBack data={data} />
            </div>
          </>
        )}
        {selection === "floral" && (
          <>
            <div className="col-custom-template px-3 mb-3 mb-md-0">
              <FloralFront data={data} />
            </div>
            <div className="col-custom-template">
              <FloralBack data={data} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TemplatePreview;
